import {
  LegislativnyMaterialFilter,
  LegislativnyMaterialFilterListApi,
  SortDirectionEnum,
} from 'elegislativa-frontend-ts-axios';
import { LegMaterialFilterListItem, LegMaterialFilterListPage } from 'elegislativa-frontend-ts-axios/api';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import LegMaterialListFilter from '../../model/legislativnyMaterial/LegMaterialListFilter';
import dateToString from '../../function/dateToString';
import LegislativnyMaterialFilterListItem from '../../model/legislativnyMaterial/LegislativnyMaterialFilterListItem';
import LegislativnyMaterialFilterListPage from '../../model/legislativnyMaterial/LegislativnyMaterialFilterListPage';
import { mapStadium } from '../../model/legislativnyMaterial/StadiumMaterialu';

const client = new LegislativnyMaterialFilterListApi(apiConfiguration(elegislativaPrefixPath));

const mapMaterial = (data: LegMaterialFilterListItem): LegislativnyMaterialFilterListItem => ({
  zaciatokStadia: data.zaciatokStadia ? new Date(data.zaciatokStadia) : undefined,
  cisloLp: data.cisloLegislativnehoMaterialu,
  nazov: data.nazov,
  stadium: mapStadium(data.stadium),
  typNazov: data.typNazov,
  datumUkonceniaPkMpk: data.datumUkonceniaPkMpk ? new Date(data.datumUkonceniaPkMpk) : undefined,
  uuid: data.uuid,
});

const map = (data: LegMaterialFilterListPage): LegislativnyMaterialFilterListPage => ({
  materialList: data.legMaterialList.map(material => mapMaterial(material)),
  number: data.number,
  size: data.size,
  totalElements: data.totalElements,
});

const mapFilterRequest = (data: LegMaterialListFilter, predbeznaInformacia: boolean): LegislativnyMaterialFilter => ({
  stadium: data.stadium,
  hladanyVyraz: data.searchTextVyraz,
  cisloLegislativnehoMaterialu: data.searchTextCislo,
  rezortneCislo: data.searchTextRezort,
  typKod: predbeznaInformacia ? 'PredbeznaInfo' : data?.typ?.kod,
  oblastKodList: data.oblastList ? data.oblastList.map(oblast => oblast.kod) : null,
  nazov: data.searchTextNazov,
  rocnik: data.searchTextRocnik,
  zodpovednyPredkladatel: data?.predkladatel?.uuid,
  zodpovednaInstitucia: data?.institucia?.uuid,
  datumZmenyOd: data.datumZmenyOd ? dateToString(data.datumZmenyOd) : null,
  datumZmenyDo: data.datumZmenyDo ? dateToString(data.datumZmenyDo) : null,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchLegislativnyMaterialFilteredPage = async (
  filter: LegMaterialListFilter,
  page?: number,
  size?: number,
  sortBy?: string,
  sortDirection?: SortDirectionEnum,
  predbeznaInformacia?: boolean,
  headers?: object,
):
  Promise<ClientResponse<LegislativnyMaterialFilterListPage>> => {
  const {
    data,
    status,
  } = await client.getLegMaterialFilteredList(
    mapFilterRequest(filter, predbeznaInformacia),
    page,
    size,
    sortBy,
    sortDirection,
    headers,
  );
  return {
    data: map(data),
    responseCode: status,
  };
};
